var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messages"},[_c('div',{staticClass:"header"},[_c('h3',{staticClass:"title"},[_vm._v("Сообщения")]),_c('toggle-button',{staticClass:"switch",attrs:{"value":true,"labels":{
        unchecked: 'все',
        checked: 'доска'
      },"width":65},on:{"change":_vm.onChangeEventHandler}})],1),_c('CardChatMessages',{staticClass:"messages-event-container",attrs:{"messages":_vm.messages,"showCardId":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }